import React from "react";
import CheckGreen from "../images/check-icon.png";
import CancelIcon from "../images/cancel-icon.png";

export default function CheckWithDateIntake(props) {
  const statusClass =
    props.checked === "checked" ? "status-signed" : "status-not-signed";

  return (
    <div className={`container-check-with-name ${statusClass}`}>
      {props.checked === "checked" ? (
        <img
          style={{
            width: "24px",
            height: "24px",
          }}
          alt=""
          src={CheckGreen}
        />
      ) : (
        <img
          style={{
            width: "24px",
            height: "24px",
          }}
          alt=""
          src={CancelIcon}
        />
      )}

      <div className="name-for-check">
        <div>{props.content}</div>
        {props.signedOnContent && (
          <div className="signed-on-intake">Signed on {props.signedOnContent}</div>
        )}
      </div>
    </div>
  );
}
